// extracted by mini-css-extract-plugin
export default {"reload-button":"evmLCE","reloadButton":"evmLCE","content":"Mh7Jvi","text-container":"b2Iyay","textContainer":"b2Iyay","text-title":"WUHSGI","textTitle":"WUHSGI","text":"AjlL7p"};